export enum MatFormFieldType {
  INPUT,
  SELECT,
  SELECT_MULTIPLE,
  DATE,
  BOOLEAN,
  INPUT_LANGUAGE,
}